import React, { useState, useEffect } from "react";
import axios from "axios";
import Meta from "../../components/Meta";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import blogimg from "../../assets/blog.jpeg";
import "../../styles/blog.css";
import { Api } from "./Api";

const BlogItem = ({ match }) => {
  const id = match.params.id;

  const [blogPost, setBlogPost] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await axios.get(`${Api}/${id}?_embed`);
        setBlogPost(result.data);
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  console.log(blogPost);

  return (
    <div>
      <div style={{ height: "72px" }} className="herobg">
        <Header />
      </div>
      <section className="container py-4">
        {loading ? (
          <div>loading...</div>
        ) : (
          <div>
            {blogPost ? (
              <div>
                <h5 className="font-normal text-black-fade mt-1">
                  {blogPost._embedded["wp:term"] &&
                    blogPost._embedded["wp:term"][0][0].name}{" "}
                  {blogPost.date.slice(0, 10)}
                </h5>
                <Meta title={`Wedevelopers - ${blogPost.title.rendered}`} />
                <h2 className="lh-small text-black my-2 d-inline-block">
                  {blogPost.title.rendered}
                </h2>
                <div className="blogsingleimg">
                  {!blogPost.featured_media ? (
                    <img
                      src={blogimg}
                      className="w-100 h-100"
                      alt="blog image"
                    />
                  ) : (
                    <img
                      src={blogPost._embedded["wp:featuredmedia"][0].source_url}
                      className="w-100 h-100"
                      alt="blog image"
                    />
                  )}
                </div>
                <div className="my-2">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: blogPost.content.rendered,
                    }}></div>
                </div>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
};

export default BlogItem;
